import { List, ListItem, ListItemText } from '@mui/material';
import { GlobalClassKeys } from 'assets/jss/common-styles';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { TopicRelationship } from 'models/ApiModels';
import * as React from 'react';
import { getTopicSecondViewAction } from "views/Timeline/Components/FeedHelpers";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const TopicRelationsRender: React.FC<{ data: TopicRelationship[]; }> = ({ data }) => {
    return (
        <List disablePadding>
            {
                data.map((v, index) => {
                    const action = getTopicSecondViewAction(v.topicId);

                    return (
                        <ListItem key={index} button dense disableGutters className={GlobalClassKeys.clickable} onClick={action} >
                            <MuiColor variant="muted">
                                <ListItemText
                                    primary={v.name}
                                    primaryTypographyProps={
                                        {
                                            color: "inherit",
                                            variant: "subtitle2"
                                        }
                                    }
                                />
                            </MuiColor>
                        </ListItem>
                    );
                })
            }
        </List>
    );
};